export const EMBED_MAX_DEPTH = 3
